import type { TranslationKey } from '@/i18n-key';

import { useAmelioTranslations } from '@/hooks';
import { useError } from '@/hooks/utils/useError';

/** Tells the reader which action of the report failed, with one message per action. */
export const useReportFailure = () => {
    const { t } = useAmelioTranslations();
    const { handleError } = useError();

    return (error: unknown, messageKey: TranslationKey) =>
        handleError({ error, data: { title: t('errors.genericTitle'), message: t(messageKey) } });
};
